import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getChatQueueController from './getChatQueueController.js'
import _module from 'module.js'
import _ from 'lodash'

const getChatQueueComponent = _.cloneDeep(getJrnDefaultComponent)
getChatQueueComponent.controller = getChatQueueController

_module.component('getChatQueue', getChatQueueComponent)
